import { Component, input } from '@angular/core'

/**
 * Shows HTML a manager wrote in the editor (an event's description). The HTML was sanitised by the
 * API when it was stored, and `[innerHTML]` runs it through Angular's sanitiser again here; never
 * bypass that with `DomSanitizer.bypassSecurityTrustHtml`. Its styles are global (`.seiri-rich-text` in
 * `libs/shared/styles/src/base.css`), since the inserted HTML has no scoping attributes.
 */
@Component({
  selector: 'seiri-rich-text',
  template: '',
  host: {
    class: 'seiri-rich-text',
    '[innerHTML]': 'html()',
  },
})
export class RichTextComponent {
  readonly html = input('')
}
